// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ReExecuteIntegrationCallRequestModel from '../../model/re-execute-integration-call-request-model';
import ReExecuteIntegrationCallRequestDTO from '../dto/re-execute-integration-call-request-dto';

export default abstract class ReExecuteIntegrationCallRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ReExecuteIntegrationCallRequestDTO>) {
    super();
    if (data) {
      this.comment = data.comment;
      this.payload = data.payload;
      this.id = data.id;
    }
  }
  /**
  */
  'comment'?: string;
  /**
  */
  'payload'?: string;
  /**
  * @type {int64}
  */
  'id'?: number;

  static toModel(dto: DeepPartial<ReExecuteIntegrationCallRequestDTO>): ReExecuteIntegrationCallRequestModel;
  static toModel(dto: DeepPartial<ReExecuteIntegrationCallRequestDTO> | undefined | null): ReExecuteIntegrationCallRequestModel | undefined;
  static toModel(dto: DeepPartial<ReExecuteIntegrationCallRequestDTO> | undefined | null): ReExecuteIntegrationCallRequestModel | undefined {
    return dto ? new ReExecuteIntegrationCallRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ReExecuteIntegrationCallRequestModel> | ReExecuteIntegrationCallRequestModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'comment': unwrapped.comment,
      'payload': unwrapped.payload,
      'id': unwrapped.id,
    } as ReExecuteIntegrationCallRequestDTO;
  }
}
